<section class="qca-page">
  <div class="page-shell">
    <a routerLink="/register" class="crumb">Select Stakeholder <span>›</span> QCA Registration</a>

    <header class="hero">
      <div class="hero-left">
        <button type="button" class="back-btn" routerLink="/register">←</button>
        <div>
          <h1>QCA Registration</h1>
          <p>Qualified Coordinating Agency - Fill in all required fields and submit. Your request will be sent to MSLDC Admin for approval.</p>
        </div>
      </div>
      <div class="hero-pill">No login required</div>
    </header>

    @if (message) {
      <div class="toast-message" [class.error]="messageType === 'error'" role="status">
        {{ message }}
      </div>
    }

    <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
      <section class="panel">
        <div class="panel-head">Basic Information</div>
        <div class="grid two">
          <label>
            <span>QCA Name *</span>
            <input formControlName="qca_name" placeholder="e.g. Maharashtra QCA Authority">
            @if (getErrorMessage('qca_name')) {
              <small class="field-error">{{ getErrorMessage('qca_name') }}</small>
            }
          </label>
          <label>
            <span>Username *</span>
            <input formControlName="username" placeholder="Auto-generated" readonly>
          </label>
          <label>
            <span>Registration Number *</span>
            <input formControlName="registration_number" placeholder="QCA-MH-2024-001">
            @if (getErrorMessage('registration_number')) {
              <small class="field-error">{{ getErrorMessage('registration_number') }}</small>
            }
          </label>
          <label>
            <span>PSS Selection *</span>
            <select formControlName="pss_selection">
              <option value="">Select PSS</option>
              <option>Kalwa</option>
              <option>Pune</option>
              <option>Nagpur</option>
            </select>
            @if (getErrorMessage('pss_selection')) {
              <small class="field-error">{{ getErrorMessage('pss_selection') }}</small>
            }
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">QCA Address</div>
        <div class="grid two">
          <label class="span-2">
            <span>Address Line 1 *</span>
            <input formControlName="address_line1" placeholder="Building / Plot No., Street">
            @if (getErrorMessage('address_line1')) {
              <small class="field-error">{{ getErrorMessage('address_line1') }}</small>
            }
          </label>
          <label>
            <span>Address Line 2</span>
            <input formControlName="address_line2" placeholder="Area / Locality">
          </label>
          <label>
            <span>City / Town *</span>
            <input formControlName="city_town" placeholder="e.g. Pune">
            @if (getErrorMessage('city_town')) {
              <small class="field-error">{{ getErrorMessage('city_town') }}</small>
            }
          </label>
          <label>
            <span>District *</span>
            <input formControlName="district" placeholder="Select District">
            @if (getErrorMessage('district')) {
              <small class="field-error">{{ getErrorMessage('district') }}</small>
            }
          </label>
          <label>
            <span>State *</span>
            <input formControlName="state" placeholder="Select State">
            @if (getErrorMessage('state')) {
              <small class="field-error">{{ getErrorMessage('state') }}</small>
            }
          </label>
          <label>
            <span>Pin Code *</span>
            <input formControlName="pin_code" placeholder="e.g. 411001">
            @if (getErrorMessage('pin_code')) {
              <small class="field-error">{{ getErrorMessage('pin_code') }}</small>
            }
          </label>
          <label>
            <span>Country *</span>
            <input formControlName="country" placeholder="India">
            @if (getErrorMessage('country')) {
              <small class="field-error">{{ getErrorMessage('country') }}</small>
            }
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Control Room Details</div>
        <div class="grid two">
          <label>
            <span>Control Room Contact No. *</span>
            <input formControlName="control_room_contact_no" placeholder="+91-20-2612XXXX">
            @if (getErrorMessage('control_room_contact_no')) {
              <small class="field-error">{{ getErrorMessage('control_room_contact_no') }}</small>
            }
          </label>
          <label>
            <span>Control Room Mobile *</span>
            <input formControlName="control_room_mobile" placeholder="+91 98765 43210">
            @if (getErrorMessage('control_room_mobile')) {
              <small class="field-error">{{ getErrorMessage('control_room_mobile') }}</small>
            }
          </label>
          <label>
            <span>Control Room Email *</span>
            <input formControlName="control_room_email" placeholder="controlroom@qca.org" type="email">
            @if (getErrorMessage('control_room_email')) {
              <small class="field-error">{{ getErrorMessage('control_room_email') }}</small>
            }
          </label>
          <label>
            <span>Control Room Fax</span>
            <input formControlName="control_room_fax" placeholder="+91-20-2612XXXX">
          </label>
          <label class="span-2">
            <span>Control Room Address *</span>
            <textarea formControlName="control_room_address" rows="3" placeholder="Full address of the control room..."></textarea>
            @if (getErrorMessage('control_room_address')) {
              <small class="field-error">{{ getErrorMessage('control_room_address') }}</small>
            }
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Nodal Officer Details</div>
        <div class="grid two">
          <label>
            <span>Full Name *</span>
            <input formControlName="nodal_full_name" placeholder="Nodal Officer Name">
            @if (getErrorMessage('nodal_full_name')) {
              <small class="field-error">{{ getErrorMessage('nodal_full_name') }}</small>
            }
          </label>
          <label>
            <span>Designation *</span>
            <input formControlName="nodal_designation" placeholder="e.g. Manager - Grid Operations">
            @if (getErrorMessage('nodal_designation')) {
              <small class="field-error">{{ getErrorMessage('nodal_designation') }}</small>
            }
          </label>
          <label>
            <span>Mobile Number *</span>
            <input formControlName="nodal_mobile_number" placeholder="+91 98765 43210">
            @if (getErrorMessage('nodal_mobile_number')) {
              <small class="field-error">{{ getErrorMessage('nodal_mobile_number') }}</small>
            }
          </label>
          <label>
            <span>Email Address *</span>
            <input formControlName="nodal_email_address" placeholder="nodal@company.com" type="email">
            @if (getErrorMessage('nodal_email_address')) {
              <small class="field-error">{{ getErrorMessage('nodal_email_address') }}</small>
            }
          </label>
          <label>
            <span>Alternate Mobile</span>
            <input formControlName="nodal_alternate_mobile" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Alternate Email</span>
            <input formControlName="nodal_alternate_email" placeholder="alternate@company.com">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Alternate Nodal Officer</div>
        <div class="grid two">
          <label>
            <span>Full Name</span>
            <input formControlName="alternate_full_name" placeholder="Nodal Officer Name">
          </label>
          <label>
            <span>Designation</span>
            <input formControlName="alternate_designation" placeholder="e.g. Manager - Grid Operations">
          </label>
          <label>
            <span>Mobile Number</span>
            <input formControlName="alternate_mobile_number" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Email Address</span>
            <input formControlName="alternate_email_address" placeholder="alternate@company.com">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Document Upload</div>
        <div class="upload-list">
          @for (document of documents; track document) {
            <div class="upload-card">
              <span class="upload-title">{{ document }} *</span>
              <input #fileInput type="file" class="file-input" (change)="onFileSelected($event, $index)" accept=".pdf,.jpg,.jpeg,.png">
              <button type="button" class="upload-box" (click)="openFilePicker($index)">
                <div class="upload-icon">⇪</div>
                <p>Drop files here or <strong>browse</strong></p>
                <small>PDF, JPG, PNG up to 10 MB each</small>
              </button>
              @if (uploadSlots[$index].file) {
                <p class="file-name">{{ uploadSlots[$index].file?.name }}</p>
              }
            </div>
          }
        </div>
      </section>

      <section class="panel declaration-panel">
        <div class="panel-head">Declaration</div>
        <div class="declaration">
          <p>
            I hereby declare that the information furnished above is true and correct to the best of my knowledge and belief.
            I understand that in the event of any information being found false or incorrect, my registration is liable to be
            cancelled without any notice. I agree to abide by all the rules, regulations, and guidelines of the RE-DSM system as
            notified by MSLDC from time to time.
          </p>
        </div>
        <label class="terms">
          <input type="checkbox" formControlName="declaration_accept">
          <span>I agree to the <strong>Terms & Conditions</strong> and <strong>Privacy Policy</strong> of the RE-DSM system.</span>
        </label>
        @if (getErrorMessage('declaration_accept')) {
          <small class="field-error declaration-error">{{ getErrorMessage('declaration_accept') }}</small>
        }
      </section>

      <footer class="footer-actions">
        <div class="note">Fields marked * are mandatory. Your registration request will be sent to the MSLDC Admin for review. No login is required to submit.</div>
        <div class="actions">
          <a routerLink="/register" class="btn ghost">Cancel</a>
          <button type="button" class="btn ghost" (click)="reset()">Reset</button>
          <button type="submit" class="btn primary">Send Request to Admin</button>
        </div>
      </footer>
    </form>
  </div>
</section>

